import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import Header from '../../components/Header';
import Modal from '../../components/Modal';
import api from '../../api';

const ICONES = ['bi-folder2', 'bi-cash-coin', 'bi-clipboard-check', 'bi-box-seam', 'bi-truck', 'bi-shop', 'bi-building', 'bi-people',
  'bi-receipt', 'bi-graph-up', 'bi-megaphone', 'bi-journal-text', 'bi-heart', 'bi-diagram-3', 'bi-shield-check', 'bi-tools'];
const toast = (title) => Swal.fire({ toast: true, position: 'bottom-end', icon: 'success', title, timer: 2600, showConfirmButton: false });

export default function Categorias() {
  const [cats, setCats] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [form, setForm] = useState(null);   // null = modal fechado
  const [mover, setMover] = useState(null); // { cat, destino }
  const [salvando, setSalvando] = useState(false);

  function carregar() {
    return api.get('/categorias')
      .then(({ data }) => setCats([...data.categorias].sort((a, b) => (a.ordem ?? 0) - (b.ordem ?? 0) || a.nome.localeCompare(b.nome))))
      .catch(err => Swal.fire('Erro', err.response?.data?.error || 'Não foi possível carregar as categorias.', 'error'))
      .finally(() => setCarregando(false));
  }
  useEffect(() => { carregar(); }, []);

  async function salvar() {
    if (!form.nome.trim()) return Swal.fire('Falta o nome', 'Dê um nome à categoria.', 'warning');
    setSalvando(true);
    const payload = { nome: form.nome.trim(), icone: form.icone || null };
    if (String(form.ordem).trim() !== '') payload.ordem = parseInt(form.ordem) || 0;
    try {
      if (form.id) await api.put(`/categorias/${form.id}`, payload);
      else await api.post('/categorias', payload);
      toast(form.id ? 'Categoria atualizada' : 'Categoria criada');
      setForm(null);
      carregar();
    } catch (err) {
      Swal.fire('Erro', err.response?.data?.error || 'Não foi possível salvar.', 'error');
    } finally { setSalvando(false); }
  }

  async function excluir(c) {
    if (c.qtd_docs > 0) return setMover({ cat: c, destino: '' });
    const r = await Swal.fire({
      icon: 'warning', title: `Excluir "${c.nome}"?`, text: 'A categoria está vazia e sai da biblioteca.',
      showCancelButton: true, confirmButtonText: 'Sim, excluir', cancelButtonText: 'Cancelar', confirmButtonColor: '#C62828',
    });
    if (!r.isConfirmed) return;
    try {
      await api.delete(`/categorias/${c.id}`);
      toast('Categoria excluída');
      carregar();
    } catch (err) {
      Swal.fire('Erro', err.response?.data?.error || 'Não foi possível excluir.', 'error');
    }
  }

  async function moverEExcluir() {
    if (!mover.destino) return Swal.fire('Escolha o destino', 'Selecione para qual categoria os documentos vão.', 'warning');
    setSalvando(true);
    try {
      const { data } = await api.delete(`/categorias/${mover.cat.id}?mover_para=${mover.destino}`);
      toast(`${data.movidos} documento(s) movido(s) e categoria excluída`);
      setMover(null);
      carregar();
    } catch (err) {
      Swal.fire('Erro', err.response?.data?.error || 'Não foi possível excluir.', 'error');
    } finally { setSalvando(false); }
  }

  return (
    <>
      <Header />
      <main className="conteudo-container" style={{ maxWidth: 860 }}>
        <Link to="/admin" className="doc-voltar"><i className="bi bi-arrow-left"></i> Administração</Link>
        <div className="adm-topo">
          <div>
            <h1>Categorias</h1>
            <p>As pastas da biblioteca de documentos. Categoria sem documento visível não aparece pro colaborador.</p>
          </div>
          <button className="btn-centrao" onClick={() => setForm({ id: null, nome: '', icone: 'bi-folder2', ordem: '' })}>
            <i className="bi bi-plus-lg me-1"></i> Nova categoria
          </button>
        </div>

        {carregando ? <div>Carregando…</div> : (
          <div className="adm-tabela-wrap">
            <table className="adm-tabela">
              <thead><tr><th>Categoria</th><th className="adm-num">Documentos</th><th className="adm-num">Ordem</th><th></th></tr></thead>
              <tbody>
                {cats.map(c => (
                  <tr key={c.id}>
                    <td><i className={`bi ${c.icone || 'bi-folder2'} me-2`} style={{ color: 'var(--verde)' }}></i><strong>{c.nome}</strong></td>
                    <td className="adm-num">{c.qtd_docs}</td>
                    <td className="adm-num">{c.ordem ?? 0}</td>
                    <td>
                      <div className="adm-acoes">
                        <button className="adm-btn-icone" title="Editar" onClick={() => setForm({ id: c.id, nome: c.nome, icone: c.icone || '', ordem: c.ordem ?? '' })}>
                          <i className="bi bi-pencil"></i>
                        </button>
                        <button className="adm-btn-icone adm-btn-icone--perigo" title="Excluir" onClick={() => excluir(c)}>
                          <i className="bi bi-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
                {cats.length === 0 && <tr><td colSpan={4} className="adm-vazio">Nenhuma categoria ainda.</td></tr>}
              </tbody>
            </table>
          </div>
        )}
      </main>

      <Modal
        aberto={!!form}
        titulo={form?.id ? 'Editar categoria' : 'Nova categoria'}
        onFechar={() => setForm(null)}
        rodape={<>
          <button className="btn btn-outline-secondary" onClick={() => setForm(null)}>Cancelar</button>
          <button className="btn-centrao" disabled={salvando} onClick={salvar}>{salvando ? 'Salvando…' : 'Salvar categoria'}</button>
        </>}
      >
        {form && (
          <>
            <label className="doc-label">Nome *</label>
            <input className="doc-input" value={form.nome} maxLength={120} autoFocus
                   onChange={e => setForm(s => ({ ...s, nome: e.target.value }))} />
            <label className="doc-label">Ícone</label>
            <div className="adm-icones">
              {ICONES.map(ic => (
                <button key={ic} type="button" title={ic} className={`adm-icone-op${form.icone === ic ? ' adm-icone-op--on' : ''}`}
                        onClick={() => setForm(s => ({ ...s, icone: ic }))}>
                  <i className={`bi ${ic}`}></i>
                </button>
              ))}
            </div>
            <label className="doc-label">Ordem</label>
            <input className="doc-input" type="number" value={form.ordem} placeholder="Em branco = vai pro fim"
                   onChange={e => setForm(s => ({ ...s, ordem: e.target.value }))} />
          </>
        )}
      </Modal>

      <Modal
        aberto={!!mover}
        titulo="Excluir categoria com documentos"
        onFechar={() => setMover(null)}
        rodape={<>
          <button className="btn btn-outline-secondary" onClick={() => setMover(null)}>Cancelar</button>
          <button className="btn btn-danger" disabled={salvando} onClick={moverEExcluir}>{salvando ? 'Movendo…' : 'Mover e excluir'}</button>
        </>}
      >
        {mover && (
          <>
            <p style={{ marginTop: 0 }}>
              <strong>{mover.cat.nome}</strong> tem <strong>{mover.cat.qtd_docs} documento(s)</strong>. Pra excluir, escolha pra onde eles vão:
            </p>
            <select className="doc-input" value={mover.destino} onChange={e => setMover(s => ({ ...s, destino: e.target.value }))}>
              <option value="">Escolha a categoria…</option>
              {cats.filter(c => c.id !== mover.cat.id).map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
            </select>
          </>
        )}
      </Modal>
    </>
  );
}
